/* AUTO-SYNCED from PsyKit.io/lib/compliance/selfConsentAge.ts — DO NOT EDIT. Regenerate with `npm run sync`. */
/** Single-state self-consent age lookup. ADVISORY ONLY — drives the live add-client
 *  UX; the server's 3-vector stacked age (lib/compliance/stateStacking.ts) is
 *  authoritative. Kept in sync with the DB seed by self-consent-age.test.ts. */
export const SELF_CONSENT_AGE: Record<string, number> = {
  CA: 12, IL: 12,
  WA: 13, FL: 13,
  PA: 14, OH: 14, MI: 14, OR: 14, WI: 14, VA: 14,
  MD: 16, NJ: 16, MN: 16,
};
export const selfConsentAge = (code: string): number => SELF_CONSENT_AGE[code] ?? 18;
